// Slider MANUAL + Swipe en móvil
(function(){
  let currentSlide = 0;
  const slides = document.querySelectorAll('.slider-slide');
  const dots = document.querySelectorAll('.dot');
  const container = document.getElementById('storySliderContainer');

  function showSlide(index){
    slides.forEach(s=>s.classList.remove('active'));
    dots.forEach(d=>d.classList.remove('active'));
    slides[index].classList.add('active');
    dots[index].classList.add('active');
  }
  window.changeSlide = function(dir){
    currentSlide += dir;
    if(currentSlide < 0) currentSlide = slides.length - 1;
    if(currentSlide >= slides.length) currentSlide = 0;
    showSlide(currentSlide);
  }
  window.goToSlide = function(i){ currentSlide = i; showSlide(currentSlide); }
  showSlide(currentSlide);

  // Teclado (izq/der)
  container.addEventListener('keydown', (e)=>{
    if(e.key === 'ArrowLeft') { e.preventDefault(); window.changeSlide(-1); }
    if(e.key === 'ArrowRight'){ e.preventDefault(); window.changeSlide(1); }
  });
  container.setAttribute('tabindex','0');

  // Swipe táctil
  let startX = 0, currentX = 0, isTouching = false;
  const SWIPE_THRESHOLD = 50; // px

  container.addEventListener('touchstart', (e)=>{
    if(!e.touches || e.touches.length===0) return;
    startX = e.touches[0].clientX;
    currentX = startX;
    isTouching = true;
  }, {passive:true});

  container.addEventListener('touchmove', (e)=>{
    if(!isTouching) return;
    currentX = e.touches[0].clientX;
  }, {passive:true});

  container.addEventListener('touchend', ()=>{
    if(!isTouching) return;
    const deltaX = currentX - startX;
    if(Math.abs(deltaX) > SWIPE_THRESHOLD){
      if(deltaX < 0) { window.changeSlide(1); } else { window.changeSlide(-1); }
    }
    isTouching = false;
  }, {passive:true});
})();
